import React, { Component } from "react";
import * as PropTypes from "prop-types";
import {
	Modal,
	Row,
	Col,
	Spin,
	Form,
	Select,
	message,
} from "antd";

import {
	timeCardService,
	justificationsService,
} from "./../../../../redux/services";

import { API_ERRO_TYPE_CANCEL } from "./../../../../config/general";

import axios from "axios";

import moment from "moment";

import { DatePickerWithMask, HourPickerWithMask } from "./../../../../components";

class ModalEdit extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			uuid: 0,
			isLoading: false,
			isSending: false,
			justifications: [],
			justificationsIsLoading: false,
		};

		this._axiosCancelJustificationsToken = null;
	}

	fetchJustifications = (value) => {
		if (this._axiosCancelJustificationsToken) {
			this._axiosCancelJustificationsToken.cancel(
				"Only one request allowed at a time."
			);
		}

		this._axiosCancelJustificationsToken = axios.CancelToken.source();

		if (!value.trim().length) {
			this.setState({
				justificationsIsLoading: false,
				justifications: [],
			});

			return false;
		}

		this.setState({
			justificationsIsLoading: true,
		});

		let params = {
			search: value,
			ativo: 1,
			orderBy: "nome:asc",
			cancelToken: this._axiosCancelJustificationsToken.token,
		};

		justificationsService
			.getAll({
				...params,
			})
			.then((response) => {
				this.setState({
					justificationsIsLoading: false,
					justifications: response.data.data,
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					justificationsIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fillForm = (data) => {
		this.setState({
			justifications: [data[0].justificativa],
		}, () => {
			this.form.setFieldsValue({
				justificativa_id: data[0]?.justificativa_id ?? null,
				data: moment(data[0].data),
				hora_inicio: data[0].hora_inicio.slice(0, 5),
				hora_fim: data[0].hora_fim.slice(0, 5),
			});
		});
	};

	resetFields = () => {
		this.setState({
			justifications: [],
			justificationsIsLoading: false,
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
		});

		timeCardService
			.justificativaShow({
				uuid: uuid,
			})
			.then((response) => {
				let item = response.data.data;

				this.setState(
					{
						isLoading: false,
					},
					() => {
						// Fill form
						this.fillForm(item);
					}
				);
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					},
				});
			});
	};

	onSubmit = () => {
		this.form.validateFields().then((values) => {
			this.setState({
				isSending: true,
			});

			timeCardService
				.justificativaEdit({
					uuid: this.state.uuid,
					empresas: [this.props.empresa.id],
					departamentos: [this.props.departamento.id],
					funcionarios: [this.props.funcionario.id],
					justificativa_id: values.justificativa_id,
					data: moment(values.data).format("YYYY-MM-DD"),
					hora_inicio: values.hora_inicio + ":00",
					hora_fim: values.hora_fim + ":00",
					status: true,
				})
				.then((response) => {
					this.setState({
						isSending: false,
					});

					// Reset fields
					this.resetFields();

					// Success message
					message.success('Registro atualizado com sucesso.');

					// Callback
					this.props.onComplete();
				})
				.catch((data) => {
					this.setState({
						isSending: false,
					});

					Modal.error({
						title: "Ocorreu um erro!",
						content: String(data),
					});
				});
		});
	};

	render() {
		const { visible } = this.props;

		const { isLoading, isSending, justifications, justificationsIsLoading } = this.state;

		return (
			<Modal
				visible={visible}
				title={(
					<div className="time-card-modal-header">
						<span className="time-card-modal-header-icon"><i className="fal fa-clipboard-list" /></span>
						<div className="time-card-modal-title">Editar justificativa parcial</div>
					</div>
				)}
				wrapClassName="modal-scroll"
				className="time-card-modal time-card-modal-divided"
				destroyOnClose={true}
				width={640}
				onCancel={this.onClose}
				maskClosable={false}
				okText={isSending ? "Salvando" : "Salvar"}
				cancelButtonProps={{ disabled: isSending }}
				onOk={this.onSubmit}
				confirmLoading={isSending}
				keyboard={!isLoading || !isSending}
				closable={!isLoading || !isSending}
				centered
			>
				<Spin spinning={isLoading} indicator={<i className="fad fa-spinner-third fa-spin fa-2x" />}>
					<Form
						ref={(el) => (this.form = el)}
						layout="vertical"
						scrollToFirstError
						onFinish={this.onFinish}
						disabled={isLoading || isSending}
					>
						<dl className="time-card-modal-info">
							<div>
								<dt>Empresa</dt>
								<dd>{this.props.empresa?.nome ?? "-"}</dd>
							</div>
							<div>
								<dt>Departamento</dt>
								<dd>{this.props.departamento?.nome ?? "-"}</dd>
							</div>
							<div>
								<dt>Funcionário</dt>
								<dd>{this.props.funcionario?.nome ?? "-"}</dd>
							</div>
						</dl>
						<Form.Item
							name="justificativa_id"
							label="Justificativa"
							rules={[{ required: true, message: "Campo obrigatório." }]}
						>
							<Select
								filterOption={false}
								allowClear
								placeholder="Selecione a justificativa"
								notFoundContent={
									justificationsIsLoading ? (
										<Spin
											indicator={
												<i className="fad fa-spinner-third fa-spin" />
											}
										/>
									) : null
								}
								onSearch={this.fetchJustifications}
								showSearch
							>
								{justifications.map((item, index) => (
									<Select.Option key={index} value={item.id}>
										{item.nome}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
						<DatePickerWithMask disabled={true} label="Data" name="data" required={true} />
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<HourPickerWithMask name="hora_inicio" label="Hora início" placeholder="HH:MM" required={true} allowMoreThan24={false} />
							</Col>
							<Col xs={24} md={12}>
								<HourPickerWithMask name="hora_fim" label="Hora fim" placeholder="HH:MM" required={true} allowMoreThan24={false} />
							</Col>
						</Row>
					</Form>
				</Spin>
			</Modal>
		);
	}
}

export default ModalEdit;
